/**
 * Captures console.warn and console.error into a ring buffer
 * for ticket diagnostic data. Calls original functions so
 * devtools output is unaffected.
 */

interface ConsoleLogEntry {
  level: "warn" | "error"
  message: string
  timestamp: number
}

const MAX_ENTRIES = 20
const MAX_MESSAGE_LENGTH = 1000
const buffer: ConsoleLogEntry[] = []
let installed = false

export function installConsoleCapture() {
  if (installed) return
  installed = true

  const originalWarn = console.warn
  const originalError = console.error

  console.warn = (...args: unknown[]) => {
    originalWarn.apply(console, args)
    pushEntry("warn", args)
  }

  console.error = (...args: unknown[]) => {
    originalError.apply(console, args)
    pushEntry("error", args)
  }
}

function pushEntry(level: "warn" | "error", args: unknown[]) {
  try {
    const message = args
      .map((a) => (typeof a === "string" ? a : JSON.stringify(a)))
      .join(" ")
      .slice(0, MAX_MESSAGE_LENGTH)

    buffer.push({ level, message, timestamp: Date.now() })
    if (buffer.length > MAX_ENTRIES) {
      buffer.shift()
    }
  } catch {
    // Never let capture logic break the app
  }
}

export function getRecentConsoleLogs(): ConsoleLogEntry[] {
  return [...buffer]
}
